module.exports = __webpack_public_path__ + "img/warehouse-yellow.579b81ee.svg";